import * as React from "react";
const SvgChevronDownSFill = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 16L6 10H18L12 16Z" }));
export default SvgChevronDownSFill;
